import { BaseModel } from "sjs-base-model";

export default class UserResetPasswordPutModel extends BaseModel {
  //USER PUT model
  message = "";
  status = "";

  constructor(data1) {
    super();

    this.update(data1);
  }
}
